import debounce from 'lodash/debounce'
import { useMemo } from 'react'

type CallbackFunction = (...args) => void
type UseDebouncedCallbackReturn = CallbackFunction & { cancel: () => void }

/**
 * @returns stable debounced callback with cancel function
 */
export const useDebouncedCallback = (callback: CallbackFunction, delayMillis?: number): UseDebouncedCallbackReturn => {
  return useMemo(() => {
    return debounce(callback, delayMillis)
  }, [callback, delayMillis])
}
